import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';


export type TraceCreateConfirmationDialogData = {
  title: string;
  text: string;
  type: string;
  index?: number[];
  cancelLabel?: string;
  continueLabel?: string;
  routePointInfo?: boolean;
}
@Component({
  selector: 'tt-trace-create-confirmation-dialog',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    A11yModule
  ],
  templateUrl: './trace-create-confirmation-dialog.component.html',
  standalone: true
})
export class TraceCreateConfirmationDialogComponent {
 public data = inject<TraceCreateConfirmationDialogData>(MAT_DIALOG_DATA); 
  constructor(
    private _dialogRef: MatDialogRef<TraceCreateConfirmationDialogComponent>,
  ) { }
}
